import React, { Fragment, memo, useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

const modalId = 'EditTranslatedDataModal';
class CustomError extends Error {}
const localeList = {
  ...window.AS.localeSettings.activeLocales,
  ja: undefined
};
delete localeList.ja;

$(document).on('click', '.doEditTranslate', e => {
  e.preventDefault();
  e.stopPropagation();
  const id = $(e.currentTarget).data('id');
  const collection = $(e.currentTarget).data('collection');

  window.openModal(`#${modalId}`);

  const container = document.getElementById('reactEditTranslatedData');
  ReactDOM.unmountComponentAtNode(container);

  ReactDOM.render(
    <EditTranslatedDataModal id={id} collection={collection} />,
    container
  );
});

const EditTranslatedDataModal = memo(({ id, collection }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (loading) {
      $(`#${modalId}`).addClass('freeze');
      return;
    }

    $(`#${modalId}`).removeClass('freeze');
  }, [loading]);

  const [ja, setJa] = useState({
    title: '',
    description: ''
  });
  const [selectedLocale, setSelectedLocale] = useState('');
  const [locales, setLocales] = useState(localeList);
  const [editData, setEditData] = useState({
    // en: {
    //   oriTitle: '',
    //   oriDescription: '',
    //   title: '',
    //   description: '',
    //   complete: false
    // }
  });
  useEffect(() => {
    fetchTranslatedData();
  }, []);
  const fetchTranslatedData = async () => {
    setLoading(true);

    try {
      const { title, description, lang = {} } = await $.ajax({
        url: `${window.AS.domains.api}/GET_TRANSLATED_DATA`,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          collection,
          id,
          session: window.Cookies.get('session')
        })
      });
      setJa({ title, description });

      let hasCompleteLocale = false;
      const newLang = {};
      const newEditData = {};
      _.forEach(locales, (obj, key) => {
        const { title: oriTitle, description: oriDescription } =
          lang[key] || {};
        const complete = !!lang[key];
        newLang[key] = {
          ...obj,
          complete
        };
        newEditData[key] = {
          oriTitle,
          oriDescription,
          title: oriTitle,
          description: oriDescription,
          complete
        };
        if (complete && (!hasCompleteLocale || key === window.hlocale)) {
          hasCompleteLocale = true;
          setSelectedLocale(key);
        }
      });

      if (!hasCompleteLocale) {
        throw new CustomError(
          window.resolveLang('翻訳中です。翻訳完了したから再度お試しください。')
        );
      }
      setLocales(newLang);
      setEditData(newEditData);
    } catch (e) {
      alert(
        e instanceof CustomError
          ? e.message
          : window.resolveLang('エラーが発生しました。')
      );
      window.closeModal();
    }

    setLoading(false);
  };

  const finishEditing = async () => {
    setLoading(true);

    const lang = {};

    for (const [
      index,
      { oriTitle, oriDescription, title, description }
    ] of Object.entries(editData)) {
      // error checking
      if (
        (oriTitle && !title.trim()) ||
        (oriDescription && !description.trim())
      ) {
        alert(
          `${window.resolveLang('翻訳文言を入力してください')}(${
            localeList[index].label
          })`
        );
        return setLoading(false);
      }
      if (oriTitle !== title) {
        lang[index] = {
          title
        };
      }
      if (oriDescription !== description) {
        lang[index] = {
          ...lang[index],
          description
        };
      }
    }

    if (!_.isEmpty(lang)) {
      try {
        await $.ajax({
          url: `${window.AS.domains.api}/EDIT_TRANSLATED_DATA`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            collection,
            id,
            session: window.Cookies.get('session'),
            lang
          })
        });

        updateTranslatedData(id, collection, lang);
      } catch (e) {
        console.log(e);
        alert(window.resolveLang('エラーが発生しました。'));
        return setLoading(false);
      }
    }

    window.closeModal();
  };

  const optionsMemo = useMemo(
    () =>
      _.map(locales, ({ label, complete }, value) => (
        <option key={value} value={value} disabled={!complete}>
          {label}
          {!complete && `(${window.resolveLang('翻訳中')})`}
        </option>
      )),
    [locales]
  );

  const { title = '', description = '' } = editData[selectedLocale] || {};

  return (
    <Fragment>
      <div>
        <div>
          <p>{window.resolveLang('日本語')}</p>
          {collection !== 'dialy' && (
            <p>
              <input type="text" readOnly value={ja.title} />
            </p>
          )}
          <textarea readOnly value={ja.description} />
        </div>
        <div>
          <select
            value={selectedLocale}
            onChange={({ target: { value } }) => setSelectedLocale(value)}
          >
            {optionsMemo}
          </select>
          {collection !== 'dialy' && (
            <p>
              <input
                type="text"
                value={title}
                readOnly={!ja.title}
                onChange={({ target: { value } }) =>
                  setEditData({
                    ...editData,
                    [selectedLocale]: {
                      ...editData[selectedLocale],
                      title: value
                    }
                  })
                }
              />
            </p>
          )}
          <textarea
            value={description}
            readOnly={!ja.description}
            onChange={({ target: { value } }) =>
              setEditData({
                ...editData,
                [selectedLocale]: {
                  ...editData[selectedLocale],
                  description: value
                }
              })
            }
          />
        </div>
      </div>
      <div>
        <button className="btnBlue" onClick={finishEditing}>
          {window.resolveLang('完了')}
        </button>
      </div>
    </Fragment>
  );
});

// update html and local objs
const updateTranslatedData = (
  id,
  collection,
  { [window.hlocale]: changedLang }
) => {
  if (!changedLang) {
    return;
  }

  if (changedLang) {
    _.forEach(changedLang, (value, field) => {
      $(`.${field}TLTE${id}`).text(value);
      $(`.${field}TLDATA${id}`).data(field, value);

      // handlebars br
      if (!window.lineBreakAndParseLink) {
        return;
      }
      $(`.${field}TLBR${id}`).html(window.lineBreakAndParseLink(value).string);
    });

    const objsToUpdate = [];

    const referenceObjects = {
      map: {
        dic: 'CurrentMap',
        push: ['CurrentSpots', 'CurrentDialies']
      },
      spot: {
        dic: 'CurrentSpots',
        push: ['CurrentDialies']
      },
      dialy: {
        dic: 'CurrentDialies'
      }
    };
    if (referenceObjects[collection]) {
      const { dic, push = [] } = referenceObjects[collection];
      objsToUpdate.push(Gdata[dic].dic[id]);
      push.forEach(currentObjs => {
        Gdata[currentObjs].ori.forEach(({ [collection]: obj = {} }) => {
          if (obj._id === id) {
            objsToUpdate.push(obj);
          }
        });
      });
    }

    objsToUpdate.forEach(obj => {
      if (obj.lang && obj.lang[window.hlocale]) {
        _.forEach(changedLang, (value, field) => {
          obj.lang[window.hlocale][field] = value;
          obj.lang_edited = true;
        });
      }
    });
  }
};
